export default __webpack_public_path__ + "static/media/map_germany.5489969f.png";